import React, { createContext, useEffect, useState } from 'react'

import { useEnv } from '@acorns/web-utils'

import { loadSalesforceScript } from '../utils/salesforce'

type AIAssistantContextType = {
  showAIAssistant: boolean
  setShowAIAssistant: (showAIAssistant: boolean) => void
  isSalesforceWidgetInitialized: boolean
  setIsSalesforceWidgetInitialized: (
    isSalesforceWidgetInitialized: boolean,
  ) => void
}
export const AIAssistantContext = createContext<AIAssistantContextType>({
  showAIAssistant: false,
  setShowAIAssistant: () => null,
  isSalesforceWidgetInitialized: false,
  setIsSalesforceWidgetInitialized: () => {},
})

export const AIAssistantProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [showAIAssistant, setShowAIAssistant] = useState<boolean>(false)
  const [isSalesforceWidgetInitialized, setIsSalesforceWidgetInitialized] =
    useState<boolean>(false)
  const { env } = useEnv()
  const salesforceScriptSrc = env.get('salesforceScriptSrc') ?? ''

  useEffect(() => {
    if (showAIAssistant) {
      loadSalesforceScript(salesforceScriptSrc)
    }
  }, [showAIAssistant, salesforceScriptSrc])

  return (
    <AIAssistantContext.Provider
      value={{
        showAIAssistant,
        setShowAIAssistant,
        isSalesforceWidgetInitialized,
        setIsSalesforceWidgetInitialized,
      }}
    >
      {children}
    </AIAssistantContext.Provider>
  )
}
